(() => {
  const configElement = document.getElementById('bb-collar-promo-config');
  if (!configElement) return;
  const config = JSON.parse(configElement.textContent);
  const productIds = new Set(config.productIds.map(Number));
  const variantIds = new Set(config.variantIds.map(Number));
  const root = window.Shopify?.routes?.root || '/';
  let queue = Promise.resolve();
  let bypassCheckout = false;
  let syncing = false;
  let knownCart = null;
  const isGift = item => item.product_id === config.giftProductId && item.properties?._bb_collar_gift === '1';
  const standalone = cart => {
    const paid = cart.items.filter(item => !isGift(item));
    return paid.length === 1 && paid[0].quantity === 1 && productIds.has(paid[0].product_id);
  };
  const desiredCodes = (cart, eligible) => {
    const codes = (cart.discount_codes || []).map(entry => entry.code);
    const promo = config.discountCode;
    if (!promo) return null;
    const others = codes.filter(code => code.toLowerCase() !== promo.toLowerCase());
    const desired = eligible ? [...others, promo] : others;
    return codes.map(code => code.toLowerCase()).sort().join(',') === desired.map(code => code.toLowerCase()).sort().join(',') ? null : desired.join(',');
  };
  const active = () => config.preview || (Date.now() >= Date.parse(config.startsAt) && Date.now() < Date.parse(config.endsAt));
  const notify = (message) => {
    let element = document.getElementById('bb-collar-promo-message');
    if (!element) {
      element = document.createElement('div');
      element.id = 'bb-collar-promo-message';
      element.setAttribute('role', 'alert');
      element.style.cssText = 'position:fixed;bottom:24px;left:16px;right:16px;z-index:10000;background:#111;color:#fff;padding:16px;border-radius:10px';
      document.body.append(element);
    }
    element.textContent = message;
  };
  const request = async (path, body) => {
    const response = await fetch(root + path, body ? { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) } : undefined);
    const data = await response.json();
    if (!response.ok) throw new Error(data.description || 'Please refresh your basket and check your free collars.');
    return data;
  };
  const desiredGifts = (cart, isActive) => {
    const groups = new Map();
    if (isActive && standalone(cart)) for (const item of cart.items) {
      if (!productIds.has(item.product_id)) continue;
      const group = item.properties?._bb_collar_group || `bar-${item.key}`;
      const selected = document.querySelector('[data-bb-collar-choice]')?.value;
      const fallback = config.giftVariants.find(v => v.id === Number(selected)) || config.giftVariants.find(v => v.title === 'Black Pair') || config.giftVariants[0];
      const giftVariant = Number(item.properties?._bb_collar_variant || fallback?.id);
      if (productIds.has(item.product_id) && group && config.giftVariants.some(v => v.id === giftVariant)) {
        const entry = groups.get(group) || { variantId: giftVariant, quantity: 0 };
        entry.quantity += item.quantity;
        groups.set(group, entry);
      }
    }
    const updates = {};
    const additions = [];
    const consumed = new Set();
    for (const item of cart.items) {
      if (item.product_id !== config.giftProductId || item.properties?._bb_collar_gift !== '1') continue;
      const group = item.properties._bb_collar_group;
      const desired = groups.get(group);
      const quantity = desired && desired.variantId === item.variant_id && !consumed.has(group) ? desired.quantity : 0;
      if (quantity) consumed.add(group);
      if (quantity !== item.quantity) updates[item.key] = quantity;
    }
    for (const [group, desired] of groups) if (!consumed.has(group)) additions.push({ id: desired.variantId, quantity: desired.quantity, properties: { _bb_collar_group: group, _bb_collar_gift: '1', Offer: 'Free collars with qualifying barbell' } });
    return { updates, additions };
  };
  const sync = () => {
    queue = queue.catch(() => {}).then(async () => {
      syncing = true;
      try {
      let cart = await request('cart.js');
      const plan = desiredGifts(cart, active());
      let changed = false;
      if (Object.keys(plan.updates).length) {
        cart = await request('cart/update.js', { updates: plan.updates });
        changed = true;
      }
      if (plan.additions.length) {
        await request('cart/add.js', { items: plan.additions });
        cart = await request('cart.js');
        changed = true;
      }
      const codes = desiredCodes(cart, active() && standalone(cart) && cart.items.some(isGift));
      if (codes !== null) {
        cart = await request('cart/update.js', { discount: codes });
        changed = true;
      }
      knownCart = cart;
      if (changed && typeof publish === 'function') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'bb-collar-promo', cartData: cart });
      // The standalone cart page otherwise keeps its server-rendered gift and totals.
      if (changed && /\/cart\/?$/.test(window.location?.pathname || '')) window.location.reload();
      return cart;
      } finally { syncing = false; }
    });
    return queue;
  };
  document.addEventListener('formdata', (event) => {
    if (!active()) return;
    const data = event.formData;
    if (data.has('items[1][id]')) return;
    const variantId = Number(data.get('id'));
    if (!variantIds.has(variantId)) return;
    const select = event.target.querySelector('[data-bb-collar-choice]');
    const giftVariant = config.giftVariants.find(v => v.id === Number(select?.value)) || config.giftVariants.find(v => v.title === 'Black Pair') || config.giftVariants[0];
    if (!giftVariant) return;
    const quantity = event.target.closest('product-info')?.querySelector('.quantity__input')?.value || data.get('quantity') || '1';
    if (Number(quantity) !== 1 || !knownCart || knownCart.items.some(item => !isGift(item))) return;
    const group = crypto.randomUUID();
    for (const [key, value] of Array.from(data.entries())) {
      if (key === 'id' || key === 'quantity' || key === 'selling_plan' || key.startsWith('properties[')) {
        data.delete(key);
        data.append(key.startsWith('properties[') ? `items[0][${key.replace('[', '][')}` : `items[0][${key}]`, value);
      }
    }
    data.set('items[0][quantity]', quantity);
    data.set('items[0][properties][_bb_collar_group]', group);
    data.set('items[0][properties][_bb_collar_variant]', String(giftVariant.id));
    data.set('items[1][id]', String(giftVariant.id));
    data.set('items[1][quantity]', quantity);
    data.set('items[1][properties][_bb_collar_group]', group);
    data.set('items[1][properties][_bb_collar_gift]', '1');
    data.set('items[1][properties][Offer]', 'Free collars with qualifying barbell');
  }, true);
  const checkout = async (event) => {
    if (bypassCheckout) return;
    const target = event.type === 'submit' ? event.submitter : event.target.closest('a,button,input');
    if (!target || !(target.name === 'checkout' || target.matches('a[href*="/checkout"]'))) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    try {
      const cart = await sync();
      if (config.preview) { notify('Preview only: the free-collar discount has not been activated.'); return; }
      const gifts = cart.items.filter(item => item.properties?._bb_collar_gift === '1');
      const giftCost = gifts.reduce((sum, item) => sum + item.original_line_price, 0);
      const collarSavings = cart.items.filter(item => item.product_id === config.giftProductId).reduce((sum,item) => sum + item.original_line_price - item.final_line_price, 0);
      if (collarSavings < giftCost) { notify('Your free-collar offer has not applied. Please remove any other discount code and check your basket before checkout.'); return; }
      bypassCheckout = true;
      if (event.type === 'submit') event.target.requestSubmit(target);
      else target.click();
      bypassCheckout = false;
    } catch (error) { notify(error.message); }
  };
  document.addEventListener('click', checkout, true);
  document.addEventListener('submit', checkout, true);
  const start = () => {
    if (typeof subscribe === 'function') subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => { if (event.source !== 'bb-collar-promo') sync().catch(error => notify(error.message)); });
    sync().catch(error => notify(error.message));
    let cartEventTimer;
    window.addEventListener('section-store:cart:updated', () => {
      if (syncing) return;
      clearTimeout(cartEventTimer);
      cartEventTimer = setTimeout(() => sync().catch(error => notify(error.message)), 150);
    });
    const bindSectionStore = () => {
      const api = window.SectionStoreCart;
      if (!api || bindSectionStore.done) return;
      bindSectionStore.done = true;
      api.onBeforeCheckout(({ checkoutUrl }) => {
        sync().then(cart => {
          if (config.preview) { notify('Preview only: the free-collar discount has not been activated.'); return; }
          const gifts = cart.items.filter(item => item.properties?._bb_collar_gift === '1');
          const cost = gifts.reduce((sum,item) => sum + item.original_line_price, 0);
          const savings = cart.items.filter(item => item.product_id === config.giftProductId).reduce((sum,item) => sum + item.original_line_price - item.final_line_price, 0);
          if (savings < cost) { notify('Your free-collar offer has not applied. Please remove any other discount code and check your basket before checkout.'); return; }
          location.assign(checkoutUrl);
        }).catch(error => notify(error.message));
        return false;
      });
    };
    window.addEventListener('section-store:cart:ready', bindSectionStore);
    bindSectionStore();
    const cartSurface = document.querySelector('cart-drawer') || document.querySelector('cart-items');
    if (cartSurface) {
      let timer;
      new MutationObserver(() => {
        clearTimeout(timer);
        timer = setTimeout(() => sync().catch(error => notify(error.message)), 300);
      }).observe(cartSurface, { childList: true, subtree: true });
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true }); else start();
  const expireOffer = () => {
    if (active()) return;
    document.querySelectorAll('[data-bb-collar-offer]').forEach(element => element.hidden = true);
    sync().catch(error => notify(error.message));
  };
  if (!config.preview) {
    const expiresIn = Date.parse(config.endsAt) - Date.now();
    if (Number.isFinite(expiresIn)) setTimeout(expireOffer, Math.max(0, Math.min(expiresIn + 25, 2147483647)));
    window.addEventListener('pageshow', expireOffer);
    window.addEventListener('focus', expireOffer);
    document.addEventListener('visibilitychange', () => { if (!document.hidden) expireOffer(); });
  }
  window.BlackBearCollarPromo = { sync, desiredGifts, desiredCodes, standalone };
})();
